interface Header {
    opened: boolean
    openedSubmenu: string | null
    lastY: number
    hidden: boolean
    elevated: boolean
    showDelay: number
    showTimer: number | null
    ready: boolean
    dir: 'up' | 'down' | 'idle'
    anchor: number
    moved: number
    init: () => void
    show: () => void
    menuLink: any
    submenuToggle: any
}

const header = (): Header => ({
    opened: false,
    openedSubmenu: null,
    lastY: 0,
    hidden: false,
    elevated: false,
    showDelay: 160,
    showTimer: null,
    ready: false,

    dir: 'idle',
    anchor: 0,
    moved: 0,

    init() {
        this.lastY = window.scrollY || 0;
        this.elevated = this.lastY > 0;
        this.$nextTick(() => {
            requestAnimationFrame(() => { this.ready = true; });
        });

        window.addEventListener('scroll', () => {
            const y = window.scrollY || 0;

            const upThreshold = 20;
            const downThreshold = 48;

            this.elevated = y > 0;

            if (y <= 0) {
                this.hidden = false;
                if (this.showTimer) { clearTimeout(this.showTimer); this.showTimer = null; }
                this.dir = 'idle';
                this.anchor = 0;
                this.moved = 0;
            }

            // Direction with hysteresis
            const newDir = y > this.lastY ? 'down' : (y < this.lastY ? 'up' : this.dir);
            if (newDir !== this.dir) {
                this.dir = newDir;
                this.anchor = y;
                this.moved = 0;
            }
            this.moved = Math.abs(y - this.anchor);

            if (this.dir === 'down') {
                if (this.moved >= downThreshold) {
                    if (!this.hidden) {
                        this.hidden = true;
                    }
                    if (this.showTimer) { clearTimeout(this.showTimer); this.showTimer = null; }
                }
            } else if (this.dir === 'up') {
                if (this.moved >= upThreshold) {
                    if (this.hidden && !this.showTimer) {
                        this.showTimer = setTimeout(() => {
                            this.hidden = false;
                            this.showTimer = null;
                        }, this.showDelay) as unknown as number;
                    }
                }
            }

            this.lastY = y;
        }, { passive: true });
    },

    show() { this.hidden = false; },

    menuLink: {},
    submenuToggle: {
        ['@click'](e: Event) {
            if (window.innerWidth >= 1024) return;

            e.preventDefault();
            const slug = this.$el.getAttribute('data-slug');
            this.openedSubmenu = this.openedSubmenu === slug ? null : slug;
        }
    }
})

export default header